<template>
  <div>
    <div class="card-container memberDetails">
      <a-form ref="detailForm" class="detail-form">
        <div class="card-title">
          运营人员基本信息
        </div>
        <div class="card-content">
          <a-row>
            <a-col :span="4">
              <a-form-item
                label="用户名"
                v-bind="formItemLayout"
              >
                {{ detail.userName }}
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item
                label="昵称"
                v-bind="formItemLayout"
              >
                {{ detail.nickName }}
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item
                label="手机号码"
                v-bind="formItemLayout"
              >
                {{ detail.mobile }}
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item
                label="运营等级"
                v-bind="formItemLayout"
              >
                <span v-if="detail.level === 1">
                  初级运营
                </span>
                <span v-if="detail.level === 2">
                  高级运营
                </span>
                <span v-if="detail.level === 3">
                  金牌运营
                </span>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item
                label="管理设备（台）"
                v-bind="formItemLayout"
              >
                {{ formData.length }}
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>

    <div class="card-container">
      <div class="title card-title">
        关联设备信息列表
      </div>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="formData"
          :loading="loading"
          :pagination="pagination"
          :row-key="record => record.index"
          :scroll="{ x: 1500 }"
          @change="handleTableChange"
        >
        </a-table>
      </div>
    </div>
    <div class="card-content mb40 mt40">
      <a-row>
        <a-col
          :span="24" type="flex" align="middle"
          style="text-align:center;"
        >
          <a-button class="mr8" @click="back">
            返回
          </a-button>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getAssessDetail } from '@/api/assessNew'
const columns = [
  {
    title: '排名',
    dataIndex: 'index',
    width: 100
  }, {
    title: '小区',
    dataIndex: 'estateName'
  },
  {
    title: '设备名称',
    dataIndex: 'name'
  },
  {
    title: '出勤天数',
    dataIndex: 'isOn'
  },
  {
    title: '缺勤天数',
    dataIndex: 'isOff'
  },
  {
    title: '运营评分均值',
    dataIndex: 'device'
    // customRender (text, record, index) {
    //   if (text) {
    //     return text + '分'
    //   } else {
    //     return '-'
    //   }
    // }
  },
  {
    title: '外环境评分均值',
    dataIndex: 'outerScore'
    // customRender (text, record, index) {
    //   if (text) {
    //     return text + '分'
    //   } else {
    //     return '-'
    //   }
    // }
  },
  {
    title: '内环境评分均值',
    dataIndex: 'innerScore'
    // customRender (text, record, index) {
    //   if (text) {
    //     return text + '分'
    //   } else {
    //     return '-'
    //   }
    // }
  },
  {
    title: '满意度评分均值',
    dataIndex: 'health'
    // customRender (text, record, index) {
    //   if (text) {
    //     return text + '分'
    //   } else {
    //     return '-'
    //   }
    // }
  },
  {
    title: '异味评分',
    dataIndex: 'smell'
    // customRender (text, record, index) {
    //   if (text) {
    //     return text + '分'
    //   } else {
    //     return '-'
    //   }
    // }
  }
]
export default {
  data () {
    return {
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      detail: {},
      formData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      loading: false,
      columns: columns
    }
  },
  mounted () {
    const detail = JSON.parse(this.$route.query.info)
    this.detail = detail
    this.getDetail()
  },
  methods: {
    getDetail () {
      this.loading = true
      const params = {
        userId: this.detail.id,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      getAssessDetail(params).then(res => {
        this.loading = false
        const result = res.result.list
        result.forEach((item, index) => {
          item['index'] = index + 1
        })
        this.formData = result
        this.pagination.total = res.result.totalCount
      })
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getDetail()
    },
    back () {
      this.$router.push({
        path: '/assess/personList'
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.memberDetails
  background-color #fff
  padding 16px 20px
  margin-bottom 20px
  font-size 12px
  color #000
</style>
